/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_NewInputs */

const cs_settings_office_legal_entity_new = /** @type {(inputs: Settings_Office_Legal_Entity_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová firma`)
};

const en_settings_office_legal_entity_new = /** @type {(inputs: Settings_Office_Legal_Entity_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New company`)
};

/**
* | output |
* | --- |
* | "New company" |
*
* @param {Settings_Office_Legal_Entity_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_new = /** @type {((inputs?: Settings_Office_Legal_Entity_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_new(inputs)
	return cs_settings_office_legal_entity_new(inputs)
});